import React, { useEffect, useState } from "react";
import { Button } from "../../../components/Button";
import ModalForm from "../../../components/ModalForm";

import { useSelector, useDispatch } from "react-redux";
import {
  resetFormData,
  setModal,
  getFormData,
  setFormData,
  submit,
} from "../../../stores/master/employeeSlice";
import { getDataOptions as getDataOptionPosition } from "../../../stores/master/positionSlice";
import Select from "../../../components/Select";

function Form(props) {
  const { formType, dataId } = props;
  const dispatch = useDispatch();
  const openPopup = useSelector((state) => state.popup.openPopup);
  const openModal = useSelector((state) => state.employee.openModal);
  const formData = useSelector((state) => state.employee.formData);
  const dataOptionPosition = useSelector((state) => state.position.dataOptions);
  const [modalTitle, setModalTitle] = useState();

  useEffect(() => {
    dispatch(resetFormData());
    dispatch(getDataOptionPosition());

    if (formType === "create") {
      setModalTitle("Add Employee");
      dispatch(setFormData({ name: "active", value: 1 }));
    } else {
      setModalTitle("Edit Employee");
      dispatch(getFormData({ id: dataId }));
    }
  }, [dispatch, formType, dataId]);

  const handleInput = (e) => {
    dispatch(setFormData(e.target));
  };

  return (
    <>
      {!openPopup.open && openModal && (
        <ModalForm
          modalTitle={modalTitle}
          modalSize="small"
          closeModal={() => dispatch(setModal(false))}
        >
          <div className="w-full">
            <div className="form-group">
              <label className="control-label">
                Full Name <span className="text-danger">*</span>
              </label>
              <input
                id="fullname"
                title="Full Name"
                type="text"
                name="fullname"
                className="form-control"
                value={formData.fullname}
                onChange={handleInput}
                required
              />
            </div>
            <div className="form-group">
              <label className="control-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                id="email"
                title="Email"
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleInput}
                required
              />
            </div>
            <div className="form-group">
              <label className="control-label">
                Username <span className="text-danger">*</span>
              </label>
              <input
                id="username"
                title="Username"
                type="text"
                name="username"
                className="form-control"
                value={formData.username}
                onChange={handleInput}
                required
              />
            </div>
            <div className="form-group">
              <label className="control-label">Password</label>
              <input
                id="password"
                title="Password"
                type="text"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleInput}
              />
            </div>
            <div className="form-group">
              <label className="control-label">
                Position <span className="text-danger">*</span>
              </label>
              <Select
                id="position_id"
                title="Position"
                name="position_id"
                placeholder={"Choose..."}
                defaultValue={dataOptionPosition.filter(
                  (option) => option.value === formData.position_id
                )}
                onChange={(e) =>
                  dispatch(
                    setFormData({ name: "position_id", value: e?.value })
                  )
                }
                options={dataOptionPosition}
                required={true}
              />
            </div>
            <div className="form-group">
              <label className="control-label">Active</label>
              <div className="form-checkbox">
                <input
                  id="active"
                  title="Active"
                  type="checkbox"
                  name="active"
                  checked={formData?.active?.toString() === "1" ? true : false}
                  onChange={(e) => {
                    if (e.target.checked) {
                      e.target.value = 1;
                    } else {
                      e.target.value = 0;
                    }
                    handleInput(e);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-8 flex gap-2">
            <Button
              title="Save"
              icon="BiSave"
              color="primary"
              onClick={() => dispatch(submit({ formType: formType }))}
            />
            <Button
              title="Cancel"
              icon="BiX"
              color="secondary"
              onClick={() => dispatch(setModal(false))}
            />
          </div>
        </ModalForm>
      )}
    </>
  );
}

export default Form;
